import { render } from "./ClientFooter.vue?vue&type=template&id=51518e60"
const script = {}

import "./ClientFooter.vue?vue&type=style&index=0&id=51518e60&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__